<div class="auth-page bg-blue-500">
  
  <div class="auth-card">
    <div class="flex align-items-center justify-content-center mb-4">
      <img src="assets/images/logo/logo-monicase-vertical.png" alt="" class="auth-logo" />
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="email">Adresse email</label>
        <input type="email" id="email" formControlName="email" placeholder="ex: user@mail.com" [readOnly]="authService.isLoading"/>
        <div class="error" *ngIf="submitted && f['email'].errors">
          <span *ngIf="f['email'].errors?.['required']">Email requis</span>
          <span *ngIf="f['email'].errors?.['email']">Email invalide</span>
        </div>
      </div>
      <div class="form-group">
        <label for="password">Mot de passe</label>
        <input type="password" id="password" formControlName="password" placeholder="••••••••" [readOnly]="authService.isLoading"/>
        <div class="error" *ngIf="submitted && f['password'].errors">
          <span *ngIf="f['password'].errors?.['required']">Mot de passe requis</span>
        </div>
      </div>
      <div class="form-options">
        <a class="forgot-password text-blue-500 pointer" (click)="onForgotPassword()">Mot de passe oublié ?</a>
      </div>
      <div class="text-red-500 mb-3" *ngIf="authService.loginError">
        {{ authService.loginErrorMsg }}
      </div>
      <p-button
        type="submit"
        label="Se connecter"
        [loading]="authService.isLoading"
        [disabled]="authService.isLoading"
        styleClass="w-full bg-blue-500"
      ></p-button>
    </form>
  </div>
</div>